import { EndpointItem } from '@wajeez-web/core/types';

// endpoint with tabs
export const withTabs = (endpoint: EndpointItem): EndpointItem => {
  return {
    type: 'container',
    endpoint: endpoint.endpoint,
    per: [],
    children: [
      {
        ...endpoint,
        endpoint: ':tab',
      },
    ],
  };
};
